<div #alert class="alert alert-danger fade show error-alert" style="padding-top: 0.15rem" role="alert">
    <i class="fas fa-exclamation-triangle align-middle ml-2"></i>
    <span class="error-text">{{errorMessage}}</span>
</div>